import { Injectable } from '@angular/core';
import { Location } from '@angular/common';
import { getCurrentUsername } from '@mode/shared/util-js';

@Injectable({
  providedIn: 'root',
})
export class WorkspaceSettingsDomainFacade {
  constructor(private location: Location) {}

  /**
   *
   * Extract owner org username from URL
   * @todo Franklin (3/23/2020): replace with the meta tag for `owner-username`
   *       when its fixed.  See {@link https://github.com/mode/issues/issues/2593}
   */
  getCurrentOrgUsername(): string | null {
    const match = this.location.path().match(/^\/organizations\/([^/]+)/);

    return match && match[1];
  }

  getCurrentUsername(): string | null {
    return getCurrentUsername(window.document);
  }

  currentOrganization(config: any, accountModelClass: any): Promise<{ _resource: any }> {
    return accountModelClass.find({
      username: this.getCurrentOrgUsername(),
      useEntryPath: true,
      ...config,
    });
  }

  currentUser(accountModelClass: any): Promise<{ _resource: any }> {
    return accountModelClass.find({
      username: this.getCurrentUsername(),
      useEntryPath: true,
    });
  }
}
